module.exports = __webpack_public_path__ + "img/humidity.19ead0f9.svg";